import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.find";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { mapState } from 'vuex';
import formMixin from '../../formMixin';
import parserTypesMixin from './typesMixin';
import get from 'lodash/get';
import pullAt from 'lodash/pullAt';
import cloneDeep from 'lodash/cloneDeep';
import { isEqual } from 'lodash';
export default {
  name: 'NiotaClassicDevicetypesPacketParserDefault',
  mixins: [formMixin, parserTypesMixin],
  props: {
    parserConfig: {
      type: Object,
      required: true
    },
    switchParserMode: {
      type: Boolean,
      required: false,
      default: false
    },
    hidePredefinedParserSelection: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      predefinedParser: {
        id: null
      },
      parserConfigInternal: {},
      lastEmittedConfig: {}
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'UiTheme'])), {}, {
    modeClass: function modeClass() {
      return this.UiTheme ? 'dark' : 'light';
    },
    parseBitsFloatRule: function parseBitsFloatRule() {
      var _this = this;

      return this.requiredRule.concat([function (v) {
        return parseInt(v) === 16 || parseInt(v) === 32 || parseInt(v) === 64 || _this.$i18n_t('NiotaClassic.DeviceTypes.form.parser.bitValidationText');
      }]);
    },
    parserTargetIsUniqueRule: function parserTargetIsUniqueRule() {
      var _this2 = this;

      return this.requiredRule.concat([function (v) {
        return /^[a-zA-Z0-9_\\.]+$/.exec(v) !== null || _this2.$i18n_t('NiotaClassic.DeviceTypes.form.parser.variableNameRule');
      }, function (v) {
        return get(_this2.parserConfigInternal, 'parseElements', []).filter(function (e) {
          return e.target === v;
        }).length === 1 || _this2.$i18n_t('NiotaClassic.DeviceTypes.form.parser.targetVariableUniqueError');
      }]);
    }
  }),
  watch: {
    parserConfigInternal: {
      handler: function handler(newVal) {
        if (isEqual(cloneDeep(newVal), cloneDeep(this.lastEmittedConfig))) {
          return;
        }

        this.emitChanges();
      },
      deep: true
    },
    parserConfig: {
      handler: function handler(val) {
        this.parserConfigInternal = cloneDeep(val);
      },
      immediate: true
    }
  },
  created: function created() {
    this.handleParserConfigChanged();
  },
  methods: {
    emitChanges: function emitChanges() {
      this.lastEmittedConfig = cloneDeep(this.parserConfigInternal);
      this.$emit('config-updated', this.parserConfigInternal);
    },
    handleParserConfigChanged: function handleParserConfigChanged() {
      if (!this.parserConfigInternal.parseElements) {
        this.parserConfigInternal.parseElements = [];
      }

      if (!this.parserConfigInternal.calculateElements) {
        this.parserConfigInternal.calculateElements = [];
      }

      var newPredefinedId = get(this.parserConfigInternal, 'custom') || null;

      if (get(this.predefinedParser, 'id') !== newPredefinedId) {
        this.predefinedParser = {
          id: get(this.parserConfigInternal, 'custom') || null
        };
        this.predefinedParserSelected();
      }

      this.emitChanges();
    },
    predefinedParserSelected: function predefinedParserSelected() {
      var _this3 = this;

      this.parserConfigInternal.custom = this.predefinedParser.id;

      if (this.parserConfigInternal.custom) {
        var foundParser = this.predefinedParserVars.find(function (p) {
          return p.id === _this3.parserConfigInternal.custom;
        }) || {}; // preserve existing variables in the config, overwrite definitions of the predefined parser

        this.parserConfigInternal.variables = _objectSpread(_objectSpread({}, foundParser.fields || {}), this.parserConfigInternal.variables || {});
      } else {
        delete this.parserConfigInternal.custom;
      }

      this.emitChanges();
    },
    addParseBitRange: function addParseBitRange(index) {
      var clonedConfig = cloneDeep(this.parserConfigInternal);

      if (!clonedConfig.parseElements) {
        clonedConfig.parseElements = [];
      } // TODO: add after index!


      clonedConfig.parseElements.splice(index + 1, 0, {
        bits: 8,
        type: 'int',
        target: ''
      });
      this.parserConfigInternal = clonedConfig;
    },
    removeParseBitRange: function removeParseBitRange(index) {
      pullAt(this.parserConfigInternal.parseElements, [index]);
      this.emitChanges();
    },
    bitRange: function bitRange(parserElementIndex) {
      var bits = 0;

      for (var i = 0; i < parserElementIndex; i++) {
        bits += parseInt(this.parserConfigInternal.parseElements[i].bits);
      }

      return "".concat(bits, "-").concat(bits + parseInt(this.parserConfigInternal.parseElements[parserElementIndex].bits) - 1);
    },
    onCalculationConfigUpdated: function onCalculationConfigUpdated(calculateElements) {
      this.parserConfigInternal.calculateElements = calculateElements;
      this.emitChanges();
    }
  }
};